import React from "react";
import { IntlProvider } from "react-intl";
import { defaultLanguage, languages, localeStore } from "@cayo/shared/i18n/locale-store";
import { FCC } from "@cayo/shared/types/react";
import { hasOwnKey } from "@cayo/shared/utils/typeUtils";

interface IMessageProviderProps {
  lang: string;
}

const MessageProvider: FCC<IMessageProviderProps> = ({ lang, children }) => {
  let locale = lang;

  if (!hasOwnKey(languages, locale) || !languages[locale]) {
    locale = defaultLanguage;
  }

  return (
    <IntlProvider
      locale={locale}
      key={locale}
      messages={localeStore.getMessages()}
      textComponent={React.Fragment}
    >
      {children}
    </IntlProvider>
  );
};

export default MessageProvider;
